<div style="margin: 20px;">
    <h2 mat-dialog-title>Complaint History</h2>
    <mat-card class="complaint-summary" appearance="outlined">
        <mat-card-content>
            <div class="complaint-info">
                <p><strong>Complaint Number:</strong> {{ data.history.complaint.complaintId }}</p>
                <p><strong>Location:</strong> {{ data.history.complaint.locationCode }}, {{ data.history.complaint.areaName }}</p>
                <p><strong>Complaint:</strong> {{ data.history.complaint.complaintDescription }}</p>
                <p><strong>Complaint Status:</strong> {{ data.history.complaint.complaintStatusMeaning }}</p>
                <p><strong>Comments:</strong> {{ data.history.complaint.complaintComments }}</p>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="job-cards" appearance="outlined" *ngIf="data.history.taskList">
        <mat-card-title style="margin: 10px;">Job Cards</mat-card-title>
        <mat-card-content>
            <table mat-table [dataSource]="data.history.taskList">

                <!-- Job Card Number Column -->
                <ng-container matColumnDef="jobCardNumber">
                    <th mat-header-cell *matHeaderCellDef> Job Card# </th>
                    <td mat-cell *matCellDef="let element"> {{ element.taskId }} </td>
                </ng-container>

                <!-- Department Column -->
                <ng-container matColumnDef="department">
                    <th mat-header-cell *matHeaderCellDef> Department </th>
                    <td mat-cell *matCellDef="let element"> {{ element.assignDepartment }} </td>
                </ng-container>

                <!-- Employee Column -->
                <ng-container matColumnDef="employee">
                    <th mat-header-cell *matHeaderCellDef> Employee </th>
                    <td mat-cell *matCellDef="let element"> {{ element.assEmpFName + ' ' + element.assignEmpLName }} </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element"> {{ getJobCardStatusValue(element.taskStatus) }} </td>
                </ng-container>

                <!-- Date Issued Column -->
                <ng-container matColumnDef="dateIssued">
                    <th mat-header-cell *matHeaderCellDef> Date Issued </th>
                    <td mat-cell *matCellDef="let element"> {{ element.startDate | date:'dd-MMM-yyyy HH:mm:ss' }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>

    <mat-card class="history-tabs" appearance="outlined">
        <mat-tab-group>
            <mat-tab label="Complaint History">
                <table mat-table [dataSource]="data.history.assignmentHist">

                    <!-- Employee Column -->
                    <ng-container matColumnDef="employee">
                        <th mat-header-cell *matHeaderCellDef> Employee </th>
                        <td mat-cell *matCellDef="let element"> {{ element.firstName + ' ' + element.lastName }} </td>
                    </ng-container>

                    <!-- Department Column -->
                    <ng-container matColumnDef="department">
                        <th mat-header-cell *matHeaderCellDef> Department </th>
                        <td mat-cell *matCellDef="let element"> {{ element.departmentName }} </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintStatusMeaning }} </td>
                    </ng-container>

                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintDate | date:'dd-MMM-yyyy HH:mm:ss'}} </td>
                    </ng-container>

                    <!-- Notes Column -->
                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef> Notes </th>
                        <td mat-cell *matCellDef="let element"> {{ element.comments }} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedComplaintColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedComplaintColumns;"></tr>
                </table>
            </mat-tab>
            <mat-tab label="Job Card History">
                <!-- Similar Table as in Complaint History -->
                <table mat-table [dataSource]="data.history.taskHist">

                    <!-- Employee Column -->
                    <ng-container matColumnDef="employee">
                        <th mat-header-cell *matHeaderCellDef> Employee </th>
                        <td mat-cell *matCellDef="let element"> {{ element.assEmpFName + ' ' + element.assignEmpLName }} </td>
                    </ng-container>

                    <!-- Department Column -->
                    <ng-container matColumnDef="department">
                        <th mat-header-cell *matHeaderCellDef> Department </th>
                        <td mat-cell *matCellDef="let element"> {{ element.assignDepartment }} </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{ getJobCardStatusValue(element.taskStatus) }} </td>
                    </ng-container>

                    <!-- Date Column -->
                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.startDate | date:'dd-MMM-yyyy HH:mm:ss'}} </td>
                    </ng-container>

                    <!-- Notes Column -->
                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef> Notes </th>
                        <td mat-cell *matCellDef="let element"> {{ element.notes }} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedComplaintColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedComplaintColumns;"></tr>
                </table>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
    <mat-dialog-actions align="center">
        <button mat-stroked-button (click)="onBackClick()">Back</button>
        <button mat-flat-button [mat-dialog-close]="event()" (click)="onOkay()">Okay</button>
    </mat-dialog-actions>
</div>